<!-- <p-button
  *appRights="[permissions.createPlatformUser]"
  label="Adaugă utilizator"
  icon="pi pi-plus"
  class="mb-2"
  (click)="createUser()"
></p-button> -->

<form [formGroup]="filtersForm" class="grid align-items-end row-gap-1 mt-2">
  <div class="col-12 lg:col-4">
    <span class="font-bold block mb-2">Interval căutare</span>
    <p-calendar
      inputId="interval"
      styleClass="w-full"
      dateFormat="dd/mm/yy"
      selectionMode="range"
      formControlName="interval"
      [showIcon]="true"
      [showOnFocus]="true"
      [placeholder]="'Data de la'"
      [panelStyle]="{
        'height': '439px'
      }"
    ></p-calendar>
  </div>

  <div class="col-12 lg:col-4">
    <span class="font-bold block mb-1">Status</span>
    <p-multiSelect
      styleClass="w-full"
      optionLabel="label"
      optionValue="value"
      formControlName="status"
      [options]="statusesOptions()"
    ></p-multiSelect>
  </div>

  <div class="col-12 lg:col-4">
    <span class="font-bold block mb-1">Identificator borderou</span>
    <p-iconField class="w-full" iconPosition="right">
      @if (filtersForm.get("identifier")?.value?.length > 0) {
        <p-inputIcon
          styleClass="pi pi-times cursor-pointer"
          (click)="patchFilters({
            identifier: ''
          })"
        />
      }
      <input
        pInputText
        class="w-full"
        placeholder="Identificator borderou"
        formControlName="identifier"
      />
    </p-iconField>
  </div>
</form>

<p-table
  class="big-table"
  styleClass="p-datatable-sm w-full"
  paginatorPosition="both"
  currentPageReportTemplate="{first} - {last} din {totalRecords} borderouri"
  dataKey="identifier"
  [first]="(filtersForm.value.page - 1) * filtersForm.value.pageSize"
  [expandedRowKeys]="expandedRows()"
  [totalRecords]="totalCount()"
  [lazy]="true"
  [value]="data()"
  [rows]="filtersForm.get('pageSize')?.value"
  [paginator]="true"
  [showCurrentPageReport]="true"
  [rowsPerPageOptions]="[25, 50, 100]"
  (onPage)="pageChanged($event)"
  (onRowExpand)="expandRow($event.data)"
  (onRowCollapse)="collapseRow($event.data)"
>
  <ng-template pTemplate="header">
    @if (loading()) {
      <tr>
        <td colspan="7">
          <p-progressBar
            mode="indeterminate"
            styleClass="w-full"
            [style]="{ height: '6px' }"
          ></p-progressBar>
        </td>
      </tr>
    }
    <tr>
      @if (hasAccessTo([permissions.viewBillingPreInvoiceDetails])) {
        <th></th>
      }
      <th>Companie</th>
      <th>Interval</th>
      <th>Sumă</th>
      <th>Zonă</th>
      <th>Status</th>
      <th></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-preInvoice let-expanded="expanded">
    <tr
      [class.borderless-row]="preInvoice.status === 'APPROVED_PENDING' || preInvoice.status === 'REJECTED_PENDING'"
      [class.bg-orange-100]="preInvoice.status === 'PENDING_APPROVAL'"
    >
      @if (hasAccessTo([permissions.viewBillingPreInvoiceDetails])) {
        <td class="py-0">
          <p-button
            pRipple
            type="button"
            size="small"
            [pRowToggler]="preInvoice"
            [text]="true"
            [rounded]="true"
            [plain]="true"
            [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
          />
        </td>
      }
      <td>
        <small class="text-gray-400 text-2xs">
          {{ preInvoice.identifier }}
        </small>
        <p class="m-0 font-bold">{{ preInvoice.billingDetails.fiscalName }}</p>
        <small class="m-0">
          CUI {{ preInvoice.billingDetails.identificationCode }},
          Reg. com. {{ preInvoice.billingDetails.tradeRegisterNumber }}
        </small><br>
        <small class="text-gray-600">
          {{ formatAddress(preInvoice.billingDetails.address) }}
        </small>
        @if (preInvoice.billingDetails.note) {
          <br>
          <small>
            Notă: {{ preInvoice.billingDetails.note }}
          </small>
        }
        @if (preInvoice.billingDetails?.contact?.email?.length) {
          <br>
          <small>
            Email: {{ preInvoice.billingDetails.contact.email }}
          </small>
        }
      </td>
      <td>
        <p class="m-0 white-space-nowrap">
          @if (preInvoice.period.start && preInvoice.period.end) {
            {{ preInvoice.period.start | date: "dd/MM/yyyy" }} -
            {{ preInvoice.period.end | date: "dd/MM/yyyy" }}
          } @else {
            <span class="text-gray-400">Necunoscut</span>
          }
        </p>
      </td>
      <td>
        <b class="m-0 text-xl">{{ preInvoice.grossAmount | currency: "RON" }}</b><br>
        <small class="text-gray-600">Valoare TVA: {{ preInvoice.vatAmount | currency: "RON" }}</small><br>
        <small class="text-gray-600">Valoare netă: {{ preInvoice.netAmount | currency: "RON" }}</small>
      </td>
      <td>
        {{ preInvoice.zone.name }}
      </td>
      <td>
        <p-tag [severity]="getStatusSeverity(preInvoice.status)" styleClass="white-space-nowrap">
          <div class="flex align-items-center gap-2 text-xs">
            <span class="flex align-items-center justify-content-center text-white border-circle z-1">
              @switch (preInvoice.status) {
                @case ("PENDING_APPROVAL") {
                  <span class="pi pi-clock text-xs"></span>
                }

                @case ("APPROVED") {
                  <span class="pi pi-check-circle text-xs"></span>
                }

                @case ("APPROVED_PENDING") {
                  <span class="pi pi-check-circle text-xs"></span>
                }

                @case ("REJECTED") {
                  <span class="pi pi-times text-xs"></span>
                }

                @case ("REJECTED_PENDING") {
                  <span class="pi pi-times text-xs"></span>
                }

                @case ("CONVERTED") {
                  <span class="pi pi-verified"></span>
                }
              }
            </span>
            <div class="flex flex-column">
              {{ statusesTranslationsList()[preInvoice.status] }}
            </div>
          </div>
        </p-tag>
      </td>
      <td>
        <div class="flex align-items-center justify-content-end gap-2">
          @if (preInvoice.status === "PENDING_APPROVAL") {
            <button
              pButton
              class="w-2rem h-2rem p-0"
              size="small"
              icon="pi pi-check"
              severity="success"
              pTooltip="Acceptă borderou"
              tooltipPosition="left"
              (click)="approve(preInvoice)"
            ></button>

            <button
              pButton
              class="w-2rem h-2rem p-0"
              size="small"
              icon="pi pi-times"
              severity="danger"
              pTooltip="Refuză borderou"
              tooltipPosition="left"
              (click)="reject(preInvoice)"
            ></button>
          }

          <button
            pButton
            class="py-2 px-3 text-xs white-space-nowrap"
            size="small"
            label="Descarcă fișiere"
            icon="pi pi-download"
            severity="primary"
            [loading]="downloading()[preInvoice.identifier]"
            (click)="preInvoiceMenu.toggle($event)"
          ></button>
        </div>
      </td>
    </tr>

    @let times = remainingTimesMap().get(preInvoice.identifier);
    @switch (preInvoice.status) {
      @case ("APPROVED_PENDING") {
        @if (preInvoice?.approval?.changeWindowEndsAt) {
          <tr class="py-1 text-xs bg-blue-100 text-blue-800">
            <td colspan="7">
              @if (isPastChangeWindow(preInvoice.approval.changeWindowEndsAt)) {
                <div class="flex align-items-center gap-2">
                  <span class="pi pi-check-circle"></span>
                  <p class="m-0">Borderoul a fost acceptat și factura urmează să fie generată în cel mai scurt timp.</p>
                </div>
              } @else {
                <div class="flex align-items-center gap-2">
                  <span class="pi pi-stopwatch"></span>
                  <p class="m-0">
                    Borderoul a fost acceptat și factura urmează să fie generată în
                    @if (times) {
                      <b>
                        {{ times.hours
                          ? (times.hours === 1 ? "urmatoarea oră" : times.full)
                          : (times.minutes === 1 ? "1 minut" : times.full)
                        }}
                      </b>
                    }.
                    Pentru a anula această acțiune, faceți click
                    <span
                      class="text-blue-500 cursor-pointer hover:underline"
                      (click)="reset(preInvoice)"
                    >aici</span>.
                  </p>
                </div>
              }
            </td>
          </tr>
        }
      }

      @case ("REJECTED_PENDING") {
        @if (preInvoice?.approval?.changeWindowEndsAt) {
          <tr class="py-1 text-xs bg-red-100 text-red-800">
            <td colspan="7">
              @if (!isPastChangeWindow(preInvoice.approval.changeWindowEndsAt)) {
                <div class="flex align-items-center gap-2">
                  <span class="pi pi-stopwatch"></span>
                  <p class="m-0">
                    Borderoul a fost refuzat. În cazul în care nu doriți acest lucru, puteți reveni asupra deciziei în
                    @if (times) {
                      <b>
                        {{ times.hours
                          ? (times.hours === 1 ? "urmatoarea oră" : times.full)
                          : (times.minutes === 1 ? "1 minut" : times.full)
                        }}
                      </b>
                    } cu un click
                    <span
                      class="text-blue-500 cursor-pointer hover:underline"
                      (click)="reset(preInvoice)"
                    >aici</span>.
                  </p>
                </div>
              } @else {
                <div class="flex align-items-center gap-2">
                  <span class="pi pi-stopwatch"></span>
                  <p class="m-0">
                    Borderoul a fost refuzat, iar timpul de revenire asupra deciziei a expirat. Acesta va fi șters în curând.
                  </p>
                </div>
              }
            </td>
          </tr>
        }
      }
    }
    <p-menu #preInvoiceMenu appendTo="body" [popup]="true"
            [model]="getPreInvoiceMenuItems(preInvoice)" [tabindex]="undefined" (onBlur)="menuClosed(preInvoice)" />
  </ng-template>
  <ng-template pTemplate="rowexpansion" let-preInvoice>
    @let preInvoiceData = preInvoicesData()[preInvoice.identifier];
    @if (preInvoiceData) {
      <tr>
        <td colspan="7">
          @let approval = preInvoiceData?.approval;
          @if (approval?.performedBy) {
            @let performedBy = approval?.performedBy;
            <div class="my-2">
              @switch (approval?.action) {
                @case ("APPROVED") {
                  <div class="bg-blue-100 text-blue-800 p-2 border-round-xs">
                    Acceptat de <b>{{ performedBy?.name }}</b>
                  </div>
                }

                @case ("REJECTED") {
                  <div class="bg-red-100 text-red-800 p-2 border-round-xs">
                    Refuzat de <b>{{ performedBy?.name }}</b>
                  </div>
                }

                @case ("PENDING") {
                  <div class="bg-gray-100 text-gray-800 p-2 border-round-xs">
                    Amânat de <b>{{ performedBy?.name }}</b>
                  </div>
                }
              }
            </div>
          }

          <p-table styleClass="p-datatable-stripped my-2" [value]="preInvoiceData.items">
            <ng-template pTemplate="header">
              <tr>
                <th>Denumire serviciu / produs</th>
                <th class="text-center">Cantitate</th>
                <th class="text-center">TVA</th>
                <th class="text-right">Preț unitar (RON)</th>
                <th class="text-right">Valoare TVA (RON)</th>
                <th class="text-right">Total (RON)</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
              <tr>
                <td>{{ item.name }}</td>
                <td class="text-center">{{ item.quantity }}</td>
                <td class="text-center">{{ item.taxPercentage }}%</td>
                <td class="text-right">{{ item.unitPrice}}</td>
                <td class="text-right">{{ item.taxAmount }}</td>
                <td class="text-right">{{ getItemTotal(item) }}</td>
              </tr>
            </ng-template>
            <ng-template pTemplate="footer">
              <tr>
                <td colspan="3">
                  <b>TOTAL</b>
                </td>
                <td class="text-right">{{ getTotalWithoutVAT(preInvoiceData) | currency: "RON" }}</td>
                <td class="text-right">{{ getTotalVAT(preInvoiceData) | currency: "RON" }}</td>
                <td class="text-right">{{ getTotalToPay(preInvoiceData) | currency: "RON" }}</td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptyMesssage">
              @if (!loading()) {
                <tr>
                  <td colspan="6">
                    <p class="text-gray-400 text-center text-lg font-bold">Nu există date.</p>
                  </td>
                </tr>
              }
            </ng-template>
          </p-table>

          @if (detailsToggled()[preInvoice.identifier]) {
            <p-divider></p-divider>

            <p-table styleClass="p-datatable-stripped" [value]="preInvoiceData.metadata[preInvoiceMetadataKeys.BOXES_COUNTS_BY_TYPE]!">
              <ng-template pTemplate="header">
                <tr>
                  <th>Tip cutie</th>
                  <th>Număr folosiri</th>
                  <th>Număr discount</th>
                  <th class="text-right">Valoare totală cutii (RON)</th>
                  <th class="text-right">Valoare discount (RON)</th>
                  <th class="text-right">Valoare finală (RON)</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-metadata let-rowIndex="rowIndex">
                <tr>
                  <td>{{ metadata.boxType.name }}</td>
                  <td>{{ metadata.total.count }}</td>
                  <td>{{ metadata.discount.count }}</td>
                  <td class="text-right">{{ metadata.total.amount }}</td>
                  <td class="text-right">{{ metadata.discount.amount }}</td>
                  <td class="text-right">{{ metadata.final.amount }}</td>
                </tr>
                <!-- @if (rowIndex === preInvoiceData.metadata[preInvoiceMetadataKeys.BOXES_COUNTS_BY_TYPE]!.length - 1) {
                  <tr>
                    <td class="font-bold">Total</td>
                    <td class="font-bold">{{ preInvoiceData.metadata[preInvoiceMetadataKeys.BOXES_COUNTS_BY_TYPE]!.reduce((acc, curr) => acc + curr.total.count, 0) }}</td>
                    <td class="font-bold">{{ preInvoiceData.metadata[preInvoiceMetadataKeys.BOXES_COUNTS_BY_TYPE]!.reduce((acc, curr) => acc + curr.discount.count, 0) }}</td>
                    <td class="font-bold">{{ preInvoiceData.metadata[preInvoiceMetadataKeys.BOXES_COUNTS_BY_TYPE]!.reduce((acc, curr) => acc + curr.total.amount, 0) }}</td>
                    <td class="font-bold">{{ preInvoiceData.metadata[preInvoiceMetadataKeys.BOXES_COUNTS_BY_TYPE]!.reduce((acc, curr) => acc + curr.discount.amount, 0) }}</td>
                    <td class="font-bold">{{ preInvoiceData.metadata[preInvoiceMetadataKeys.BOXES_COUNTS_BY_TYPE]!.reduce((acc, curr) => acc + curr.final.amount, 0) }}</td>
                  </tr>
                } -->
              </ng-template>
              <ng-template pTemplate="footer">
                <tr>
                  @let totals = calculateBoxesTotal(preInvoiceData.metadata.boxes_counts_by_type);
                  <td class="font-bold">TOTAL</td>
                  <td class="font-bold">{{ totals.count }}</td>
                  <td class="font-bold">{{ totals.discountCount }}</td>
                  <td class="font-bold text-right">{{ totals.amount.toFixed(2) | currency: "RON" }}</td>
                  <td class="font-bold text-right">{{ totals.discountAmount.toFixed(2) | currency: "RON" }}</td>
                  <td class="font-bold text-right">{{ totals.finalAmount.toFixed(2) | currency: "RON"  }}</td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptyMesssage">
                @if (!loading()) {
                  <tr>
                    <td colspan="6">
                      <p class="text-gray-400 text-center text-lg font-bold">Nu există date.</p>
                    </td>
                  </tr>
                }
              </ng-template>
            </p-table>

            <p-divider></p-divider>

            <p-table styleClass="p-datatable-stripped" [value]="preInvoiceData.metadata[preInvoiceMetadataKeys.EXTRA_SERVICES_COUNT]!">
              <ng-template pTemplate="header">
                <tr>
                  <th>Tip serviciu</th>
                  <th>Număr folosiri</th>
                  <th>Valoare totală (RON)</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-service>
                <tr>
                  <td>{{ service.kind }}</td>
                  <td>{{ service.count }}</td>
                  <td>{{ service.amount }}</td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                @if (!loading()) {
                  <tr>
                    <td class="text-center" colspan="5">
                      <b class="text-gray-400">Fară servicii extra.</b>
                    </td>
                  </tr>
                }
              </ng-template>
            </p-table>

            <p-divider></p-divider>

            @let reportedRequestsTotal = (preInvoiceData.metadata.pick_up_request_reported ?? 0) +
            (preInvoiceData.metadata.drop_off_request_reported ?? 0);
            <p-table styleClass="p-datatable-striped" [value]="[1]">
              <ng-template pTemplate="header">
                <tr>
                  <th rowspan="2">Tip</th>
                  <th colspan="2" class="text-center border-left-1">Luna precedentă</th>
                  <th colspan="2" class="text-center border-x-1">Luna curentă</th>
                </tr>
                <tr>
                  <th class="text-center border-left-1">AWB-uri</th>
                  <th class="text-center border-left-1">Cutii folosite</th>
                  <th class="text-center border-left-1">AWB-uri</th>
                  <th class="text-center border-x-1">Cutii folosite</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body">
                <tr>
                  <td>Pickup</td>
                  <td class="text-center">{{ preInvoiceData.metadata.boxes_count_pick_up_previous_month?.unique }}</td>
                  <td class="text-center">{{ preInvoiceData.metadata.boxes_count_pick_up_previous_month?.total }}</td>
                  <td class="text-center">{{ preInvoiceData.metadata.boxes_count_pick_up_current_month?.unique }}</td>
                  <td class="text-center">{{ preInvoiceData.metadata.boxes_count_pick_up_current_month?.total }}</td>
                </tr>
                <tr>
                  <td>DropOff</td>
                  <td class="text-center">{{ preInvoiceData.metadata.boxes_count_drop_off_previous_month?.unique }}</td>
                  <td class="text-center">{{ preInvoiceData.metadata.boxes_count_drop_off_previous_month?.total }}</td>
                  <td class="text-center">{{ preInvoiceData.metadata.boxes_count_drop_off_current_month?.unique }}</td>
                  <td class="text-center">{{ preInvoiceData.metadata.boxes_count_drop_off_current_month?.total }}</td>
                </tr>
                <tr>
                  <td>Reportate</td>
                  <td class="text-center">0</td>
                  <td class="text-center">0</td>
                  <td class="text-center">{{ reportedRequestsTotal }}</td>
                  <td class="text-center">{{ reportedRequestsTotal }}</td>
                </tr>
              </ng-template>
              <ng-template pTemplate="footer">
                <!-- Pre invoice data variable declared before the table -->
                @let lastMonthAWBTotal = (preInvoiceData.metadata.boxes_count_pick_up_previous_month?.unique ?? 0) + (preInvoiceData.metadata.boxes_count_drop_off_previous_month?.unique ?? 0);
                @let lastMonthUsedBoxesTotal = (preInvoiceData.metadata.boxes_count_pick_up_previous_month?.total ?? 0) + (preInvoiceData.metadata.boxes_count_drop_off_previous_month?.total ?? 0);
                @let currentMonthAWBTotal = (preInvoiceData.metadata.boxes_count_pick_up_current_month?.unique ?? 0) + (preInvoiceData.metadata.boxes_count_drop_off_current_month?.unique ?? 0) + reportedRequestsTotal;
                @let currentMonthUsedBoxesTotal = (preInvoiceData.metadata.boxes_count_pick_up_current_month?.total ?? 0) + (preInvoiceData.metadata.boxes_count_drop_off_current_month?.total ?? 0) + reportedRequestsTotal;
                <tr>
                  <td>TOTAL</td>
                  <td class="text-center">{{ lastMonthAWBTotal }}</td>
                  <td class="text-center">{{ lastMonthUsedBoxesTotal }}</td>
                  <td class="text-center">{{ currentMonthAWBTotal }}</td>
                  <td class="text-center">{{ currentMonthUsedBoxesTotal }}</td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                @if (!loading()) {
                  <tr>
                    <td class="text-center text-gray-400" colspan="5">
                      Nu există date
                    </td>
                  </tr>
                }
              </ng-template>
            </p-table>
          } @else {
            <button
              pButton
              label="Vezi detalii"
              size="small"
              (click)="toggleDetailsFor(preInvoice)"
            ></button>
          }
        </td>
      </tr>
    } @else {
      <tr>
        <td colspan="7">
          <p-skeleton height="10rem" styleClass="w-full"></p-skeleton>
        </td>
      </tr>
    }
  </ng-template>
  <ng-template pTemplate="emptymessage">
    @if (!loading()) {
      <tr>
        <td colspan="8">
          <p class="text-gray-400 text-center text-lg font-bold">Nu există borderouri.</p>
        </td>
      </tr>
    }
  </ng-template>
</p-table>
